export const SET_CODE = 'set_Code'
export const SET_TOKEN = 'set_Token'
export const SET_NAME = 'set_Name'
export const SET_ROLES = 'set_Roles'
